export default "__VITE_ASSET__SMTM04Wh__"